import { combineReducers } from 'redux';
import effectiveData, { fetchEffectiveData } from './effectiveDataReducer';
import changeRecords, { fetchChangeRecords } from './changeRecordsReducer';

export default combineReducers({
  effectiveData,
  changeRecords,
});

export const fetchBasicInfoChangeRecords = fetchChangeRecords;
export const fetchBasicInfoEffectiveData = fetchEffectiveData;



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/screens/BasicInfo/reducers/index.js
 **/